(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["protection-configurator"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initProtectionConfigurator(root) {
      if (!root || root.dataset.protectionConfigInitialized) return;
      root.dataset.protectionConfigInitialized = 'true';
      var scope = root.closest('[data-protection-config-scope]') || root;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-config-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-config-panel]'));
      var total = root.querySelector('[data-setup-total]');
      var addButton = root.querySelector('[data-add-setup]');
      var error = root.querySelector('[data-setup-error]');
      var status = root.querySelector('[data-setup-status]');

      function activePanel() {
        return root.querySelector('[data-config-panel]:not([hidden])');
      }

      function priceFor(row) {
        var variant = row.querySelector('[data-setup-variant]');
        var option = variant && variant.options ? variant.options[variant.selectedIndex] : null;
        return parseInt(option ? option.getAttribute('data-price') : row.getAttribute('data-price'), 10) || 0;
      }

      function selected(row) {
        if (row.hidden) return false;
        var check = row.querySelector('[data-setup-check]');
        var quantity = row.querySelector('[data-setup-quantity]');
        return (!check || check.checked) && quantity && !quantity.disabled;
      }

      function quantityFor(row) {
        var input = row.querySelector('[data-setup-quantity]');
        if (!input || input.disabled || !input.checkValidity()) return 0;
        var quantity = Number(input.value);
        return Number.isInteger(quantity) && quantity >= 1 && quantity <= 20 ? quantity : 0;
      }

      function money(cents) {
        var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
        return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
      }

      function syncTriggers() {
        scope.querySelectorAll('[data-add-to-setup]').forEach(function (trigger) {
          var row = root.querySelector('[data-custom-product="' + trigger.getAttribute('data-add-to-setup') + '"]');
          var added = row && selected(row);
          trigger.setAttribute('aria-pressed', added ? 'true' : 'false');
          trigger.textContent = added ? root.dataset.addedLabel : root.dataset.addLabel;
        });
      }

      function syncEmptyState(panel) {
        var empty = panel.querySelector('[data-setup-empty]');
        if (!empty) return;
        var hasVisibleRows = Array.prototype.some.call(panel.querySelectorAll('[data-setup-row]'), function (row) { return !row.hidden; });
        empty.hidden = hasVisibleRows;
      }

      function update() {
        var sum = 0;
        var hasItems = false;
        var panel = activePanel();
        if (!panel) return;
        panel.querySelectorAll('[data-setup-row]').forEach(function (row) {
          var quantity = quantityFor(row);
          var price = priceFor(row);
          var rowSelected = selected(row);
          var line = rowSelected && quantity ? price * quantity : 0;
          var unitPrice = row.querySelector('[data-unit-price]');
          var lineTotal = row.querySelector('[data-line-total]');
          if (unitPrice) unitPrice.textContent = money(price);
          if (lineTotal) lineTotal.textContent = money(line);
          sum += line;
          hasItems = hasItems || rowSelected;
        });
        total.textContent = money(sum);
        addButton.disabled = !hasItems;
        syncEmptyState(panel);
        syncTriggers();
      }

      function activate(index, focus) {
        tabs.forEach(function (tab, i) {
          var active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
        });
        if (focus) tabs[index].focus();
        clearError();
        update();
      }

      function clearError() {
        error.textContent = '';
        error.hidden = true;
      }

      function collectItems(panel) {
        var items = [];
        var rows = panel.querySelectorAll('[data-setup-row]');
        for (var i = 0; i < rows.length; i += 1) {
          var row = rows[i];
          if (!selected(row)) continue;
          var quantityInput = row.querySelector('[data-setup-quantity]');
          var quantity = quantityFor(row);
          if (!quantity) {
            quantityInput.reportValidity();
            quantityInput.focus();
            return null;
          }
          var variant = row.querySelector('[data-setup-variant]');
          if (variant && variant.value) items.push({ id: parseInt(variant.value, 10), quantity: quantity });
        }
        return items;
      }

      function errorMessage(reason) {
        return reason && reason.userMessage ? reason.userMessage : root.dataset.errorMessage;
      }

      function onConfigChange(event) {
        if (!event.target.matches('[data-setup-check], [data-setup-variant], [data-setup-quantity]')) return;
        clearError();
        update();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(index, false); });
        tab.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
        });
      });

      root.addEventListener('change', onConfigChange);
      root.addEventListener('input', onConfigChange);

      scope.addEventListener('click', function (event) {
        var remove = event.target.closest('[data-setup-remove]');
        if (remove && root.contains(remove)) {
          var removedRow = remove.closest('[data-setup-row]');
          var removedCheck = removedRow.querySelector('[data-setup-check]');
          if (removedCheck) removedCheck.checked = false;
          removedRow.hidden = true;
          status.textContent = removedRow.dataset.productTitle + ' ' + root.dataset.removedLabel;
          clearError();
          update();
          var activeTab = root.querySelector('[data-config-tab][aria-selected="true"]');
          if (activeTab) activeTab.focus();
          return;
        }
        var trigger = event.target.closest('[data-add-to-setup]');
        if (!trigger) return;
        var row = root.querySelector('[data-custom-product="' + trigger.getAttribute('data-add-to-setup') + '"]');
        if (!row) return;
        row.hidden = false;
        var check = row.querySelector('[data-setup-check]');
        check.checked = true;
        activate(1, false);
      });

      addButton.addEventListener('click', function () {
        var items = collectItems(activePanel());
        if (items === null) return;
        if (!items.length) {
          error.textContent = root.dataset.emptyMessage;
          error.hidden = false;
          return;
        }
        error.hidden = true;
        addButton.disabled = true;
        fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          if (response.ok) return;
          return response.json().catch(function () { return {}; }).then(function (data) {
            var err = new Error('add failed');
            if (data && typeof data.description === 'string') err.userMessage = data.description;
            throw err;
          });
        }).then(function () {
          addButton.disabled = false;
          if (window.OUGIST && window.OUGIST.refreshCart && window.OUGIST.openCart) {
            return window.OUGIST.refreshCart().catch(function (refreshError) {
              if (window.console && console.warn) console.warn('cart refresh failed:', refreshError);
            }).then(function () { window.OUGIST.openCart(addButton); });
          }
          window.location.href = root.dataset.cartUrl;
        }).catch(function (reason) {
          error.textContent = errorMessage(reason);
          error.hidden = false;
          addButton.disabled = false;
          addButton.focus();
        });
      });

      update();
    }

    document.querySelectorAll('[data-protection-config]').forEach(initProtectionConfigurator);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-protection-config]').forEach(initProtectionConfigurator);
    });
  }());
  } catch(e) { console.error(e); }
})();

})();
